// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".code-btn[data-v-e2cc8c9a],.form-btn[data-v-e2cc8c9a]{cursor:pointer}.code-btn[data-v-e2cc8c9a]{display:inline-block;width:20%;text-align:center;border-left:none!important;border-radius:0 10px 10px 0!important}.disabled[data-v-e2cc8c9a]{background:rgba(239,239,239,.3);color:rgba(16,16,16,.3)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
